import markers from './markers';
function LocationMap(options, mapElement){
	this.mapElement = mapElement;
	this.locations = options.locations;
	this.overlays = options.overlays;
	this.themeUrl = options.themeUrl;
	this.googleMarkers = [];
	this.menuElements = [];

	//default options
	this.options = {
		zoomLvl: 15,
		mapType: 'roadmap'
	};

	//voeg input opties samen met default opties
	for (let attrname in options) { this.options[attrname] = options[attrname]; }

	this.setupMap();
}

LocationMap.prototype.setupMap = function(){
	//Create map
	this.googleMap = this.createAndReturnMap();

	//All bounds of markers/overlays
	const bounds = new google.maps.LatLngBounds();

	//Add markers
	this.locations.forEach(location => {
		let position = new google.maps.LatLng(location.lat, location.lng);

		let marker = new google.maps.Marker({
			position: {
				lat: location.lat,
				lng: location.lng
			},
			icon: {
				url: this.options.themeUrl + '/' + this.getMarkerSrc(location.marker_type, markers),
				scaledSize: location.marker_type === 'default' ? new google.maps.Size(40, 55.5) : new google.maps.Size(40, 40),
				anchor: location.marker_type === 'default' ? new google.maps.Point(20, 55.5) : new google.maps.Point(20, 20)
			},
			map: this.googleMap
		});

		if (location.marker_text){
			const infowindow = new google.maps.InfoWindow({
				content: location.marker_text
			});

			google.maps.event.addListener(marker, 'click', function(e) {
				infowindow.open(this.googleMap, marker);
			});
		}

		this.googleMarkers.push(marker);

		bounds.extend(position);
	});


	//Load marker navigation
	if (this.options.showMarkerMenu){
		this.mapElement.appendChild(this.createNavigation());
	}

	//Add overlays
	if (this.overlays){

		//Create overlays
		this.overlays.forEach(overlay => {
			this.createOverlay(overlay);
		});

	}

	//Center map on 1 marker, if more markers make all markers visible.
	if (this.locations.length === 1){
		this.googleMap.setCenter( bounds.getCenter() );
	}
	else {
		this.googleMap.fitBounds(bounds);
	}
};

LocationMap.prototype.createAndReturnMap = function( defaultLocation ) {
	if (!defaultLocation) {
		defaultLocation = this.location;
	}

	const mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		panControl: true,
		streetViewControl: false,
		center: defaultLocation,
		mapTypeId: this.options.mapType
	};

	const googleMap = new google.maps.Map(this.mapElement, mapOptions);

	if (this.options.mapType === 'roadmap'){
		const styles = [
			{
				featureType: 'poi',
				elementType: 'labels',
				stylers: [
					{ visibility: 'off' }
				]
			},{
				stylers: [
					{ lightness: 30 },
					{ saturation: -30 },
					{ gamma: 0.8 }
				]
			},{
				featureType: 'landscape'  }
		];

		googleMap.mapTypes.set('map_style', new google.maps.StyledMapType(styles, { name: 'Styled Map' }));
		googleMap.setMapTypeId('map_style');
	}

	if (this.options.mapType === 'roadmap') {

	}

	return googleMap;
};

LocationMap.prototype.createNavigation = function(){
	let categories = [];

	this.locations.forEach(location => {
		categories.push(location.marker_type);
	});

	const uniqueCategories = categories.filter( (value, index) => categories.indexOf(value) === index);

	const navigationElement = document.createElement('nav');
	navigationElement.setAttribute('class', 'kaart-navigation-wrapper');

	const navigationMenuElement = document.createElement('ul');
	navigationMenuElement.setAttribute('class', 'kaart-navigation');

	uniqueCategories.forEach(category => {
		let navigationMenuItemElement = document.createElement('li');
		navigationMenuItemElement.setAttribute('class', 'is-active kaart-navigation-menu-item voorziening-cat-' + category);
		navigationMenuItemElement.setAttribute('data-category', category);

		let navigationMenuButtonElement = document.createElement('button');
		navigationMenuItemElement.appendChild(navigationMenuButtonElement);

		navigationMenuButtonElement.addEventListener('click', (e) => {
			this.updateNavigation(e, this.googleMarkers, this.googleMap);
		});

		let labelElement = document.createElement('span');
		labelElement.setAttribute('class', 'kaart-navigation-menu-item-label');
		labelElement.appendChild(document.createTextNode(category));

		navigationMenuItemElement.appendChild(labelElement);

		navigationMenuElement.appendChild(navigationMenuItemElement);
	});

	navigationElement.appendChild(navigationMenuElement);

	return navigationElement;
};

LocationMap.prototype.updateNavigation = function(e, markers, map){
	const target = e.target.parentNode;
	const clickedCategory = e.target.parentNode.getAttribute('data-category');

	target.classList.toggle('is-active');

	markers.forEach(marker => {
		if ( marker.icon.url.includes(clickedCategory) && target.classList.contains('is-active' )){
			marker.setMap(map);
		}
		else if ( marker.icon.url.includes(clickedCategory) && !target.classList.contains('is-active') ){
			marker.setMap(null);
		}
	});
};

LocationMap.prototype.getMarkerSrc = function(slug, markers) {

	const markersSource = markers.filter(markerSrc => markerSrc.match(new RegExp('marker-' + slug + '\.[0-9a-f]+\.png')));

	return markersSource.length < 1 ? '' : markersSource[0];
};

LocationMap.prototype.createOverlay = function( overlay ) {

	const overlayMap = new google.maps.GroundOverlay(

		overlay.image_url,
		{
			north: parseFloat(overlay.north),
			east: parseFloat(overlay.east),
			south: parseFloat(overlay.south),
			west: parseFloat(overlay.west)
		}

	);

	overlayMap.setMap( this.googleMap );

};

export default LocationMap;